import React from 'react';

const ServiceTerms = React.lazy(() => import('../../modules/terms/ServiceTerms'));
const PrivacyTerms = React.lazy(() => import('../../modules/terms/PrivacyTerms'));
const PersonalInfoTerms = React.lazy(() => import('../../modules/terms/PersonalInfoTerms'));
const MarketingTerms = React.lazy(() => import('../../modules/terms/MarketingTerms'));

export const termsRoutesConfig = [
  {
    path: '/terms/service',
    element: <ServiceTerms />,
  },
  {
    path: '/terms/privacy',
    element: <PrivacyTerms />,
  },
  {
    path: '/terms/personal-info',
    element: <PersonalInfoTerms />,
  },
  {
    path: '/terms/marketing',
    element: <MarketingTerms />,
  },
];
